import { api } from "constants/RotasAPI";
import useFetch from "hooks/useFetch";
import toast from "react-hot-toast";
import { Page } from "types/dto/Page";
import { ProcessoJudicialHistoricoDTO } from "types/dto/ProcessoJudicialHistoricoDTO";
import { RequestBuscarHistoricosProcessosJudiciais } from "types/dto/RequestBuscarHistoricosProcessosJudiciais";

export const useGetVisualizarProcessoJudicialHistoricos = (
  processoId: number,
  request: RequestBuscarHistoricosProcessosJudiciais
) => {
  const onError = () => {
    toast.error("Erro ao buscar os historicos do processo judicial");
  };

  const config = {
    staleTime: 1000 * 60 * 5,
    retry: 5,
  };

  return useFetch<Page<ProcessoJudicialHistoricoDTO>>({
    key: ["processos-judiciais-historicos", request],
    url: `${api.processosJudiciaisHistorico.getVisualizarProcessosJudiciaisHistoricos}/${processoId}`,
    onError,
    params: request,
    config: config,
  });
};
